import React, { useState } from "react";
import { catSolidColors } from "../../utils/catColors";

export type Category = {
  id: number;
  name: string;
  image?: string | null;
  department?: "kitchen" | "bar" | "both";
};

export default function CategoryBar({
  categories,
  activeCat,
  onPick,
}: {
  categories: Category[];
  activeCat?: number;
  onPick: (id: number) => void;
}) {
  const [pressedId, setPressedId] = useState<number | null>(null);

  return (
    <div style={{ padding: "10px 12px", overflowX: "auto" }}>
      <div
        style={{
          display: "grid",
          gridAutoFlow: "column",
          gridTemplateRows: "repeat(2,1fr)",
          gap: 10,
          minHeight: 96,
        }}
      >
        {categories.map((cat) => {
          const active = activeCat === cat.id;
          // ⚠️ bez hook-ova u petlji — ovo je običan poziv funkcije
          const c = catSolidColors(cat.name);

          return (
            <button
              key={cat.id}
              onMouseDown={() => setPressedId(cat.id)}
              onMouseUp={() => setPressedId(null)}
              onMouseLeave={() => setPressedId(null)}
              onClick={() => onPick(cat.id)}
              style={{
                height: 44,
                padding: "0 16px",
                borderRadius: 14,
                fontWeight: 800,
                letterSpacing: 0.2,
                color: c.text,
                border: c.border,
                background: active ? c.activeGrad : c.grad,
                boxShadow: active ? c.shadow : "0 4px 12px rgba(0,0,0,.08)",
                cursor: "pointer",
                transition:
                  "transform .08s ease, box-shadow .2s ease, background .15s ease",
                transform: pressedId === cat.id ? "scale(.98)" : "scale(1)",
                outline: "none",
              }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  c.hoverGrad)
              }
              onMouseOut={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  active ? c.activeGrad : c.grad)
              }
            >
              {cat.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
